/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { lazy, Suspense, useState } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./../Loadmore/load-more.m.css";
import { getTextColor } from "../../../utils/utils";

const getTemplate = templateName => {
  switch (templateName) {
    case "ArrowFourColGrid":
      return lazy(() => import("../../Rows/FourColGrid"));
    case "ArrowThreeColGrid":
      return lazy(() => import("../../Rows/ThreeColGrid"));
    case "ArrowOneColStoryList":
      return lazy(() => import("../../Rows/OneColStoryList"));
    default:
      return lazy(() => import("../../Rows/ThreeColGrid"));
  }
};

export const ExtendedLoadMore = ({ config, componentName }) => {
  const showButton = get(config, ["showButton"], true);
  const btnText = get(config, ["buttonText"], "Read More");
  const theme = get(config, ["theme"], "");
  const textColor = getTextColor(theme);

  /* Open an array to maintain load-more initiated components to re-render */
  const [components, setComponents] = useState([]);

  const addComponent = async event => {
    event.persist();
    const collectionSlug = event.target.parentElement.getAttribute("data-collection-slug");
    const offset = event.target.parentElement.getAttribute("data-collection-offset");
    const limit = event.target.parentElement.getAttribute("data-collection-limit");

    const Component = getTemplate(componentName);

    const { items } = await (await fetch(
      `/api/v1/collections/${collectionSlug}?item-type=story&offset=${offset}&limit=${limit}`
    )).json();

    if (items.length) {
      const updatedOffset = parseInt(offset) + parseInt(limit);
      event.target.parentElement.setAttribute("data-collection-offset", updatedOffset);
    }

    const updatedCompList = [
      ...components,
      {
        Component,
        props: {
          collection: {
            items
          },
          isLoadMoreVisible: false
        },
        componentName
      }
    ];

    setComponents(updatedCompList);
  };

  if (!showButton) return null;

  /* TODO: !HACK! Remove this line post deployment */
  const componentStyles = componentName => (componentName === "ArrowOneColStoryList" ? { marginLeft: 0 } : {});

  return (
    <>
      {components.map(({ Component, props }, index) => (
        <div style={{ maxWidth: 1172, margin: "auto" }} key={`extendedLoadMoreBase-key-${index}`}>
          <Suspense fallback={<div>Loading...</div>}>
            <Component {...props} />
          </Suspense>
        </div>
      ))}
      <div
        className="arr--button"
        styleName={`button ${textColor} default`}
        style={componentStyles(componentName)}
        onClick={addComponent}
      >
        {btnText}
      </div>
    </>
  );
};

ExtendedLoadMore.propTypes = {
  collection: PropTypes.object,
  template: PropTypes.string,
  componentName: PropTypes.string,
  config: PropTypes.object,
  collectionSlug: PropTypes.string
};
